// extracted by mini-css-extract-plugin
export var blockBtn = "courseDuration-module--block-btn--e6a43";
export var courseDuration = "courseDuration-module--course-duration--19a5e";
export var courseDuration__info = "courseDuration-module--course-duration__info--4d38b";
export var courseDuration__selection = "courseDuration-module--course-duration__selection--8eae0";
export var courseDuration__text = "courseDuration-module--course-duration__text--37b28";
export var courseDuration__textBig = "courseDuration-module--course-duration__text--big--19445";
export var courseDuration__textMiddle = "courseDuration-module--course-duration__text--middle--71bed";
export var courseDuration__textSmall = "courseDuration-module--course-duration__text--small--37089";
export var courseDuration__title = "courseDuration-module--course-duration__title--8f9e8";
export var courseDuration__wrapper = "courseDuration-module--course-duration__wrapper--f1e07";
export var mainBtn = "courseDuration-module--main-btn--6cf36";
export var mainTitle = "courseDuration-module--main-title--fbad4";